export const assessmentTemplate = [
  {
    _id: "eos5Pillars",
    omniAudit: {
      auditVersion: "1",
      omniRevision: "1",
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: "1",
      writtenBy: null,
      createdBy: "rlund3",
      createdDate: "2024-05-23T00:00:00Z",
      modifiedBy: "rickyadmin",
      modifiedDate: "2024-05-23T00:00:00Z",
      isActive: true,
    },
    omniData: {
      omniType: "eos5Pillars",
      omniTypeVersion: 1,
      title: "Empire OS 5 Pillars Assessment",
      purpose: "Gather information about your 5 pillars",
      description:
        "The information you provide will help us understand your where your empire is currently at.",
      duration: "Around 5 minutes",
      directions:
        "Follow the onscreen instructions after you begin.</br></br>You can take this assessment again any time your empire grows.",
      attribution: "",
      validated: "false",
      selfAssessment: true,
      startDate: null,
      completeDate: null,
      questions: [
        {
          omniID: "eosOB2L",
          shortTitle: "leadership",
          numberText: "2",
          text: "Leadership",
          subText: "this is sub text",
          helpText: "This is help text",
          instructions: "These are instructions",
          displayType: "numberScale",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "1",
              text: "1",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "2",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "3",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "4",
              text: "4",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "5",
              text: "5",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "6",
              text: "6",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "7",
              text: "7",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "8",
              text: "8",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "9",
              text: "9",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "10",
              text: "10",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "eosOB2O",
          shortTitle: "operations",
          numberText: "2",
          text: "Operations",
          subText: "this is sub text",
          helpText: "This is help text",
          instructions: "These are instructions",
          displayType: "numberScale",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "1",
              text: "1",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "2",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "3",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "4",
              text: "4",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "5",
              text: "5",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "6",
              text: "6",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "7",
              text: "7",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "8",
              text: "8",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "9",
              text: "9",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "10",
              text: "10",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "eosOB2M",
          shortTitle: "marketing",
          numberText: "2",
          text: "Marketing",
          subText: "this is sub text",
          helpText: "This is help text",
          instructions: "These are instructions",
          displayType: "numberScale",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "1",
              text: "1",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "2",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "3",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "4",
              text: "4",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "5",
              text: "5",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "6",
              text: "6",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "7",
              text: "7",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "8",
              text: "8",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "9",
              text: "9",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "10",
              text: "10",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "eosOB2F",
          shortTitle: "finance",
          numberText: "2",
          text: "Finance",
          subText: "this is sub text",
          helpText: "This is help text",
          instructions: "These are instructions",
          displayType: "numberScale",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "1",
              text: "1",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "2",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "3",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "4",
              text: "4",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "5",
              text: "5",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "6",
              text: "6",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "7",
              text: "7",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "8",
              text: "8",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "9",
              text: "9",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "10",
              text: "10",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "eosOB2P",
          shortTitle: "personnel",
          numberText: "2",
          text: "Personnel",
          subText: "this is sub text",
          helpText: "This is help text",
          instructions: "These are instructions",
          displayType: "numberScale",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "1",
              text: "1",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "2",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "3",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "4",
              text: "4",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "5",
              text: "5",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "6",
              text: "6",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "7",
              text: "7",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "8",
              text: "8",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "9",
              text: "9",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "10",
              text: "10",
              subText: "Sub Text",
              helpText: "Help Text",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
      ],
      assessmentResults: { finalResult: null },
    },
  },
];
export const assessmentScoring = [
  {
    typeID: "phq9",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 0,
        formula: null,
        questions: [],
      },
    ],
  },
];
